"use client";
import { useEffect } from "react";
import SmartlookClient from "smartlook-client";
import { usePathname } from "next/navigation";
import useIsClient from "@/hooks/useIsClient";
import useShouldFire from "./useShouldFire";

function useSmartlook(smartlook_code: string, refresh?: boolean) {
  const pathname = usePathname();
  const client = useIsClient();
  const shouldFire = useShouldFire();
  useEffect(() => {
    if (!client || !smartlook_code || !shouldFire) return;
    if (pathname) {
      // Set the user's current page URL as a user property
      SmartlookClient.navigation(pathname);
    }
  }, [pathname, client, smartlook_code, refresh, shouldFire]);

  function trackEvent(
    eventName: string,
    props: {
      [key: string]: string | number | boolean;
    },
  ) {
    SmartlookClient.track(eventName, props);
  }

  return { trackEvent };
}

export default useSmartlook;
